module.exports = __webpack_public_path__ + "img/JT_icons01_64px_ChallengerOrange.670caa71.svg";